<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="KeHuList" data-title="附件">
      <el-upload
        :show-file-list="false"
        :auto-upload="false"
        multiple
        :on-change="onFileChange"
      >
        <el-button
          type="primary"
          icon="Upload"
          @click="
            delete state.selectId;
            state.showInfo = true;
          "
          class="!text-xs"
          style="border-radius: 8px"
        >
          上传
        </el-button>
      </el-upload>
    </div>
    <div
      class="mt-2 p-2.5 flex flex-wrap gap-5"
      v-if="state.list_data?.length > 0"
    >
      <div
        class="bg-white rounded !w-44 !h-36 flex flex-col items-center justify-center"
        v-for="(item, index) in state.list_data"
        :key="item"
      >
        <el-image
          v-if="['png', 'jpg', 'jpeg'].includes(item.attachment?.file_ext)"
          class="w-32 h-20"
          :src="item.attachment?.file_url"
          :initial-index="index"
          :preview-src-list="
            state.list_data?.map((m) => m.attachment?.file_url)
          "
          preview-teleported
        />
        <div
          class="!w-32 !h-20 p-5 flex flex-col items-center justify-center text-xs rounded-lg bg-white"
          v-else
        >
          <el-icon color="#a2a2a2" size="30"><Document /></el-icon>
          <span class="text-center">{{ item.attachment?.filename }}</span>
        </div>
        <ul class="flex items-center justify-center mt-2">
          <el-button type="primary" plain link @click="onDownLoad(item)">
            <template #icon>
              <el-icon :size="16" class="font-bold">
                <Download />
              </el-icon>
            </template>
          </el-button>
          <el-button type="danger" plain link @click="onDelete(item)">
            <template #icon>
              <el-icon :size="16" class="font-bold">
                <Delete />
              </el-icon>
            </template>
          </el-button>
        </ul>
      </div>
    </div>
    <div class="text-center" v-else>
      <el-image :src="require('@/assets/images/nodata.png')" />
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  hotel_attachment_page,
  hotel_attachment_add,
  hotel_attachment_delete,
} from "@/http/hotel";
import { onDeleteConfirm } from "@/utils/funcs";
import { post_response } from "@/utils/funcs";
import { attachment_upload } from "@/http/attachment";

class InitFormData {
  params = {
    limit: 0,
  };
}

export default {
  props: {
    hotel_id: Number,
  },
  setup(props) {
    const state = reactive({ ...new InitFormData() });
    onMounted(() => {
      state.params.hotel_id = props.hotel_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      hotel_attachment_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    const onFileChange = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          const { data } = res.data;
          hotel_attachment_add({
            hotel_id: props.hotel_id,
            name: data[0].origin_filename,
            attachment_id: data[0].id,
          }).then((res) => {
            post_response(res, () => {
              onLoad();
            });
          });
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(hotel_attachment_delete, row.id, onLoad, {
        filed: "酒店附件",
        name: row.name,
      });
    };

    const onDownLoad = (row) => {
      window.open(row.attachment?.file_url);
    };

    return { state, props, onLoad, onFileChange, onDelete, onDownLoad };
  },
};
</script>

<style lang="less" scoped></style>
